import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import RamoAtividadeService from "./ramoAtividadeService"
import FormList from 'base/FormList'

export default function RamoAtividadeList() {

    const [service] = useState(() => new RamoAtividadeService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_rati',
        dsName: 'descricao_rati',
        mainField: { name: 'descricao_rati', label: 'Descrição' },
        advFields: [
            { name: 'codigo_rati', label: 'Código', type: 'integer', inputMode: 'numeric' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (

        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_rati" sortable header="Ramo de atividade"></Column>
        </FormList >
    )
}
